import { api } from 'helpers/api';
import {
  SubmitSurveyRequest,
  Customer,
  Profile,
  LoyaltyData,
  PurchaseVoucherResponse,
  VoucherList,
  Offers,
  Marketing,
  OnboardedStatus,
  PurchaseVoucherRequest,
  CarouselOffers,
  SurveyQuestions,
  Answer,
  SubmitReceiptCodeRequest,
  ReferralCode,
  RedemptionSuccessMessage,
  Transactions,
} from 'models';

const getUserData = async () => api.get<Customer>('customer');

const getReferralCode = async () => api.get<ReferralCode>('customer/referral-code');

const sendReferralCode = (referralCode: string) =>
  api.post(`customer/referral-code/${referralCode}`);

const sendUserData = async (user: Profile) =>
  api.post<Profile, Profile>('customer/edit-profile', user);

const getLoyaltyData = async () => api.get<LoyaltyData>('customer/stats');

const getSurveyData = async () => api.get<SurveyQuestions>('survey');

const sendSurveyData = async (answers: Answer[]) =>
  api.post<null, SubmitSurveyRequest>('survey', { answers });

const getOffersData = async () => api.get<Offers>('offers');

const getVouchersData = async () => api.get<VoucherList>('vouchers');

const getCarouselOffersData = async () => api.get<CarouselOffers>('offers/carousel');

const sendPurchasedData = async (id: number, quantity: number) =>
  api.post<PurchaseVoucherResponse, PurchaseVoucherRequest>(`vouchers/purchase`, {
    offerId: id,
    quantity,
  });

const getTransactionData = async () => api.get<Transactions>('customer/transactions');

const getOnboardedStatus = async () => api.get<OnboardedStatus>('customer/onboarded');

const sendOnboardedStatus = async () => api.post<null, null>('customer/onboarded');

const sendMarketingPreference = async (optIn: boolean, isNewSignUp?: boolean) =>
  api.post<Marketing, Marketing>('customer/marketing-preference', { optIn, isNewSignUp });

const getSurpriseVoucher = async () =>
  api.post<PurchaseVoucherResponse, null>('vouchers/surprise-voucher');

const sendRevealedVoucher = async (voucherId: number) =>
  api.post<VoucherList, null>(`vouchers/reveal/${voucherId}`);

const sendRedemptionCode = async (receiptCode: string) =>
  api.post<RedemptionSuccessMessage, SubmitReceiptCodeRequest>('points/claim', { receiptCode });

export {
  getUserData,
  getReferralCode,
  sendUserData,
  getOffersData,
  getVouchersData,
  getCarouselOffersData,
  sendPurchasedData,
  getLoyaltyData,
  getTransactionData,
  getOnboardedStatus,
  sendOnboardedStatus,
  sendMarketingPreference,
  getSurveyData,
  sendSurveyData,
  getSurpriseVoucher,
  sendRevealedVoucher,
  sendRedemptionCode,
  sendReferralCode,
};
